import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_CARD_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_BUTTONS(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.BUTTONS, name: name, contents: [] };
  //DEPRECATED BUTTONS
  BH.button("RAGAI_BUTTON", "{{text:text=Button Name}}\n bei klick: {{aktion:statement[@check=ACTION,OVERLAY]}}", `
      {text:{{text}},
      onClick: async function(){
      RAGAI.EVENTS.trigger("RAGAI.BUTTON.CLICK", {text: {{text}}});
      {{aktion}}
      }},`);
  BH.button("RAGAI_BUTTON_TEXT", "{{text:text=Button Name}}", "{{text}},")
  BH._custom("RAGAI_BUTTON_OUTPUT", "@output:BUTTON\nButton: {{text}}\n bei klick: {{aktion:statement[@check=ACTION,OVERLAY]}}", `{text:{{text}},\n      onClick: async function(){\n      RAGAI.EVENTS.trigger("RAGAI.BUTTON.CLICK", {text: {{text}}});\n      {{aktion}}\n      }}`, { colour: BLOCKLY_COLORS.BUTTONS, inputsInline: true });
  BH._custom("RAGAI_BUTTON_OUTPUT_IF", "@output:BUTTON\nButton wenn {{bedingung[@check=Boolean]}}:\n{{text}}\n bei klick: {{aktion:statement[@check=ACTION,OVERLAY]}}", `({{bedingung}} ? {text:{{text}},\n      onClick: async function(){\n      RAGAI.EVENTS.trigger("RAGAI.BUTTON.CLICK", {text: {{text}}});\n      {{aktion}}\n      }} : null)`, { colour: BLOCKLY_COLORS.BUTTONS, inputsInline: true });
  BH.button("RAGAI_BUTTON_TEXT_2", "{{text}}", "{{text}},");
  cat.contents = [
    BH.label(name),
    {
      kind: 'block', type: 'RAGAI_BUTTON_OUTPUT_NEW',
      inputs: {
        TEXT: {
          block: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Button Name' }
          },
          shadow: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Button Name' }
          }
        }
      }
    } as any,

    {
      kind: 'block', type: 'CARD_BUTTONS_NEW',
      inputs: {
        ADD0: {
          block: {
            type: 'RAGAI_BUTTON_OUTPUT_NEW',
            inputs: {
              TEXT: {
                shadow: {
                  type: BLOCKLY_DUMMY.STRING,
                  fields: { text: 'Button Name' }
                }
              }
            }
          }
        },
        CSS_INPUT: {
          shadow: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'my-theme' }
          }
        }
      }
    } as any,
    BH.card("STAGE_LISTBTN", "Stage:\n ㅤㅤ", "[Buttons für Stageauswahl im Chatverlauf anzeigen]", "await RAGAI.CARDS.stageListButtons();"),
    {
      kind: 'block', type: 'ANSWER_OPTIONS_NEW',
      inputs: {
        ADD0: {
          block: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Option 1' }
          },
          shadow: {
            type: BLOCKLY_DUMMY.STRING,
            fields: { text: 'Option 1' }
          }
        }
      }
    } as any
  ];
  return cat;
}
